<template>
	<div class="typeahead"
		:style="this.styles">
		<input class="col-md-12"
			ref="input"
			type="text"
			:autocomplete="autocomplete"
			v-model="query"
			:disabled="disabled"
			:required="required"
			:readonly="readonly"
			:name="name"
			@input="debounce"
			:placeholder="placeholder"
			:minlength="minlength ? minlength : ''"
			:maxlength="maxlength ? maxlength : ''"
			:style="this.inputStyles"
			@blur="blur"
		/>
		<a v-if="query && !readonly" href @click.prevent="remove()" class="rem-btn" title="delete entry">&#10006;</a>
		<div v-if="showlist === true"
		class="typeaheadlist col-md-12 extended">
			<p role="button" v-for="(item, i) in items"
				@click="select(item)"
				:key="i">{{phraseToDisplay(item)}}</p>
			<p v-if="!items.length && searched">No items found</p>
		</div>
	</div>
</template>
<script>
const debounce = require('lodash.debounce')
export default {
	props: {
		'url': {
			type: String,
			required: true
		},
		'url2': {
			type: String,
			required: false,
            default: ''
		},
		'placeholder': {
			type: String,
			required: false,
			default: ''
		},
		'min': {
			type: Number,
			required: false,
			default: 1
		},
		'dataKey': {
			type: String,
			required: false,
			default: 'data'
		},
		'dataKey2': {
			type: String,
			required: false,
			default: ''
		},
		'filterKey': {
			type: String,
			required: false,
			default: 'q'
		},
		'filterKey2': {
			type: String,
			required: false,
			default: ''
		},
		'multipageQuery': {
			type: Boolean,
			required: false,
			default: false
		},
		'prefix': {
			type: String,
			required: false,
			default: ''
		},
		'sufix': {
			type: String,
			required: false,
			default: ''
		},
		'prefix2': {
			type: String,
			required: false,
			default: ''
		},
		'sufix2': {
			type: String,
			required: false,
			default: ''
		},
		'name': {
			type: String,
			required: false,
			default: ''
		},
		'value': {
			type: [String, Object],
			required: false,
			default: ''
		},
		'auth': {
			type: Boolean,
			required: false,
			default: true
		},
		'displayKey': {
			type: String,
			required: false,
			default: 'Name'
		},
		'displayKey2': {
			type: String,
			required: false,
			default: 'Name'
		},
		'displayPhrase': {
			type: [Function, null],
			required: false,
			default: null
		},
		'disabled': {
			type: [String, Boolean],
			required: false,
			default: false
		},
		'required': {
			type: [String, Boolean],
			required: false,
			default: false
		},
		'autocomplete': {
			type: [String, Boolean],
			required: false,
			default: 'nope'
		},
		'clearOnSelect': {
			type: Boolean,
			required: false,
			default: false
		},
		'selectedValueProp': {
			type: String,
			required: false,
			default: ''
		},
		'styles': {
			type: Object,
			required: false,
			default: () => { return {} }
		},
		'inputStyles': {
			type: Object,
			required: false,
			default: () => { return {} }
		},
		'minlength': {
			type: Number,
			required: false,
			default: 0
		},
		'maxlength': {
			type: Number,
			required: false,
			default: 0
		},
        'cleanApi': {
			type: Boolean,
			required: false,
			default: false
        },
        'cleanApi2': {
			type: Boolean,
			required: false,
			default: false
        },
		'readonly': {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data () {
		return {
			items: [],
			paginatedItems: [],
			searchTerm: '',
			query: '',
			showlist: false,
			searched: false
		}
	},
	computed: {
		formattedURL () {
			let actualURL = this.url

			// Replace {{CLIENT}} with corporation name
			let regex = /{{(.*?)}}/g
			let find = regex.exec(actualURL)

			if (find) {
				if (find.length > 1 && find[1].length) {
					// cleanup heading/trailing spaces within the double curly brackets
					find[1] = find[1].trim()
				}
				if (find[1] === 'CLIENT') {
					actualURL = this.url.replace(/{{(.*?)}}/g, this.$route.params.client)
				} else if (find[1] === 'API_BASE_URL') {
					actualURL = this.url.replace(/{{(.*?)}}/g, `${window.API_BASE_URL}`)
				} else if (find[1] === 'PUBLIC_BASE_URL') {
					actualURL = this.url.replace(/{{(.*?)}}/g, `${window.PUBLIC_BASE_URL}`)
				} else if (find[1] === 'AGENCY_BASE_URL') {
					actualURL = this.url.replace(/{{(.*?)}}/g, `${window.AGENCY_BASE_URL}`)
				} else if (find[1] === 'AGENCY_BASE_API') {
					actualURL = this.url.replace(/{{(.*?)}}/g, `${window.AGENCY_BASE_URL}/api.php`)
				}
			}

			if (actualURL.slice(0, 4) === 'http' || actualURL.slice(0, 2) === '//') {
				// absolute URL
			} else {
				// relative URL, so start with basePath
				let tempURL = window.API_BASE_URL
				// make sure the relative part starts with /
				if (this.url.slice(0, 1) !== '/') {
					tempURL += '/'
				}
				// add relative path
				tempURL += actualURL

				actualURL = tempURL
			}
			return actualURL
		},
		formattedURL2 () {
			let actualURL = this.url2

			// Replace {{CLIENT}} with corporation name
			let regex = /{{(.*?)}}/g
			let find = regex.exec(actualURL)

			if (find) {
				if (find.length > 1 && find[1].length) {
					// cleanup heading/trailing spaces within the double curly brackets
					find[1] = find[1].trim()
				}
				if (find[1] === 'CLIENT') {
					actualURL = this.url2.replace(/{{(.*?)}}/g, this.$route.params.client)
				} else if (find[1] === 'API_BASE_URL') {
					actualURL = this.url2.replace(/{{(.*?)}}/g, `${window.API_BASE_URL}`)
				} else if (find[1] === 'PUBLIC_BASE_URL') {
					actualURL = this.url2.replace(/{{(.*?)}}/g, `${window.PUBLIC_BASE_URL}`)
				} else if (find[1] === 'AGENCY_BASE_URL') {
					actualURL = this.url2.replace(/{{(.*?)}}/g, `${window.AGENCY_BASE_URL}`)
				} else if (find[1] === 'AGENCY_BASE_API') {
					actualURL = this.url2.replace(/{{(.*?)}}/g, `${window.AGENCY_BASE_URL}/api.php`)
				}
			}

			if (actualURL.slice(0, 4) === 'http' || actualURL.slice(0, 2) === '//') {
				// absolute URL
			} else {
				// relative URL, so start with basePath
				let tempURL = window.API_BASE_URL
				// make sure the relative part starts with /
				if (this.url2.slice(0, 1) !== '/') {
					tempURL += '/'
				}
				// add relative path
				tempURL += actualURL

				actualURL = tempURL
			}
			return actualURL
		}
	},
	methods: {
		phraseToDisplay (item) {
			let q = item[this.displayKey]
			if (this.displayPhrase !== null && typeof this.displayPhrase === 'function') {
				q = this.displayPhrase(item)
			}
			return q
		},
		staticQuery () {
			const config = {
                url: `${this.formattedURL}&${this.filterKey}=${encodeURIComponent(this.prefix + this.query + this.sufix)}`,
				ingoreBaseUrl: true,
				method: 'GET'
			}
			if (this.auth) {
				config['withCredentials'] = true
			}
			// this.$http(config).then((res) => {
            let dispatchAction = 'callApi'
            if (this.cleanApi) {
                dispatchAction = 'cleanApi'
            }
            this.showlist = false
			this.$store.dispatch(dispatchAction, config).then((res) => {
				// const obj = res[this.dataKey]; // .data._embedded;
				// Object.keys(obj).forEach((key) => {
				// 	this.items = obj[key];
				// });
				let obj = res
				for (let k of this.dataKey.split('.')) {
					obj = obj[k]
				}
				if (!obj.length) {
					this.searched = true
				}
				this.items = obj // [this.dataKey];
                if (this.url2) {
                    // add second request, if url2 provided
                    const config2 = {
                        url: `${this.formattedURL2}&${this.filterKey2 || this.filterKey}=${encodeURIComponent(
                            (this.prefix2 || this.prefix) + this.query + (this.sufix2 || this.sufix)
                        )}`,
                        ingoreBaseUrl: true,
                        method: 'GET'
                    }
                    if (this.auth2) {
                        config['withCredentials'] = true
                    }
                    // this.$http(config).then((res) => {
                    let dispatchAction = 'callApi'
                    if (this.cleanApi2 || this.cleanApi) {
                        dispatchAction = 'cleanApi'
                    }
                    this.$store.dispatch(dispatchAction, config2).then((res2) => {
                        let obj = res2
                        console.log(obj)
                        const dataK = this.dataKey2 || this.dataKey
                        for (let k of dataK.split('.')) {
                            obj = obj[k]
                        }
                        if (!obj.length) {
                            this.searched = true
                        }
                        this.items = this.items.concat(obj)
				        this.showlist = true
                    }).catch((err) => {
                        this.$store.commit('toast/_addError', 'Request2 failed!')
                        console.error(err)
                    })
                } else {
				    this.showlist = true
                }
			}).catch((err) => {
				this.$store.commit('toast/_addError', 'Request failed!')
				console.error(err)
			})
		},
		paginatedQuery () {
			const config = {
				baseURL: `${this.url}&${this.filterKey}=${this.prefix}${this.query}${this.sufix}`,
				method: 'GET'
			}
			if (this.auth) {
				config['withCredentials'] = true
			}
			this.$http(config).then((res) => {
				const obj = res
				this.$emit('listenmultiresp', obj)
			}).catch((err) => {
				console.error(err)
			})
		},
		select (item) {
			this.query = item[this.displayKey]
			if (this.displayPhrase !== null && typeof this.displayPhrase === 'function') {
				this.query = this.displayPhrase(item)
			}
			if (this.selectedValueProp) {
				this.query = item[this.selectedValueProp]
			}
			this.$emit('typeaheadSelect', item, this.name)
			this.showlist = false
			if (this.clearOnSelect) {
				this.query = ''
			}
		},
		blur () {
			setTimeout(() => {
				this.showlist = false
			}, 500)
		},
		resetQuery () {
			this.$emit('listenresetquery', this.name)
		},
		runQuery () {
			if (!this.query.length) {
				this.searched = false
			}
			// Check min length of the query string
			if (this.query.length >= this.min) {
				// Check if query is for a paginated resource
				if (this.multipageQuery != true) {
					this.staticQuery()
				} else {
					this.paginatedQuery()
				}
			} else if (this.query.length == '0') {
				this.items.length = 0
				this.resetQuery()
			}
		},
		remove () {
			this.$emit('typeaheadRemove', this.name)
			this.query = ''
			this.showlist = false
			this.items.length = 0
		}
	},
	created () {
		this.debounce = debounce(this.runQuery, 500)
		if (this.value) {
			this.query = this.value
		}
		// if (this.disabled) {
		// 	this.$refs.input.attr('disabled', 'disabled')
		// }
	},
	watch: {
		'$props.value': {
			handler (n) {
				this.query = n
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.typeahead {
	display: inline-block;
	position: relative;
	padding:3px 0;

	> input.error {
		border:1px solid red !important;
	}

	&input {
		display: block;
	}
	&.form-control {
		height:36px;
		> input {
			border: none !important;
			margin-top: -1px;
			height: 32px !important;
			&[readonly] {
				background-color:#eee;
			}
		}
	}
	&.disabled,
	&[disabled] {
		border:none;
		pointer-events:none;
		> input[type="text"][disabled] {
			border: none;
			background: #eee;
			font-style: normal;
			color: #888 !important;
			pointer-events:none;
		}
	}
	.rem-btn {
		position:absolute;
		color:red;
		font-weight: 600;
		display: block;
		padding: 10px;
		top: 3px;
		right: 4px;
		left: auto;
		margin-top: -5px;
		&:hover {
			transform:scale(1.4);
		}
	}
}
.typeaheadlist {
	position: absolute !important;
	z-index: 9999;
	// top: 30px;
	// border: 1px solid #ededed;
	// background: #ffffff;
	// border-radius: 3px;
	top: 44px;
    border: 1px solid #000;
    background: #32537d;
    color: #ddd;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    min-width:99%;
	p {
		display: block;
		padding: 1px 15px;
		margin: 2px 0;
        padding: 0.75em 12em 0.75em 1.5em;
        margin: 0;

		&:hover {
			background: #2f397d;
			color:#ffffff;
			cursor: pointer;
            background-color: #0000004a;
		}
	}
}
</style>
